<template>
  <div class="relative"
       @mouseenter="showTooltip"
       @mouseleave="hideTooltip"
  >
    <div v-if="isVisible"
         class="tooltip-container-bottom"
    >
      <span>{{ text }}</span>
      <span class="tooltip-arrow-bottom"></span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  methods: {
    showTooltip () {
      this.isVisible = true
    },
    hideTooltip () {
      this.isVisible = false
    }
  }
}
</script>
